import { Component, OnInit } from '@angular/core';
import { QnSbnDataServiceService } from '../../services/qn-sbn-data-service.service';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { OneWebComponentsAngularModule } from '@one/angular';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dl-daily-summary-report',
   standalone: true,
  imports: [OneWebComponentsAngularModule,CommonModule,FormsModule,ReactiveFormsModule],
  templateUrl: './daily-summary-report.component.html',
  styleUrls: ['./daily-summary-report.component.scss']
})
export class DailySummaryReportComponent implements OnInit {
  public sendToControl = new FormControl('',[ Validators.required, Validators.email]);
  constructor(
     private _QnSbnDataService: QnSbnDataServiceService,
  ) {  
     this._QnSbnDataService.DailyReportEnabled$.subscribe(
       res=>{
         this.isDailySummaryEnabled = res;
       }
     )
  }
  public isDailySummaryEnabled: boolean = false;
  public reportContent = ['Deliveries', 'Failures', 'Feedback Submitted'];
  public selected = new Set<string>();
  public sendTo: string;
  public storedData: any;
  public emailRequired: boolean = false;
  public invalidEmail: boolean = false;
  public emailTouched: boolean = false;

  ngOnInit(): void {
    this._QnSbnDataService.mappingData$.subscribe(storeData=>{
      this.storedData = storeData;
    })
    this._QnSbnDataService.mappingData$.subscribe(observer=>{
      if(!this._QnSbnDataService.isEmpty(observer['dailyReportContent'])){
        const selectedContent = observer['dailyReportContent'];
        this.selected = new Set<string>(selectedContent);
      } else {
       
        this.selected.clear();
      }
      if(!this._QnSbnDataService.isEmpty(observer['dailyReportSendTo'])){
        this.sendTo = observer['dailyReportSendTo'].sendTo;
        this.sendToControl.setValue(this.sendTo, { emitEvent: false });
      } else {
       
        this.sendTo = '';
        this.sendToControl.setValue('', { emitEvent: false });
      }
    })
    if (!this.isDailySummaryEnabled) {
      
      this._QnSbnDataService.getMappedQnsbnData([], "DailySummaryReportContent");
      this._QnSbnDataService.getMappedQnsbnData({sendTo: ''}, "DailySummaryReportSendTo");
    }
      this.sendToControl.valueChanges.subscribe(value=>{
        this.sendTo = value;
         const strictEmailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if(this.sendTo == ""){
          this._QnSbnDataService.getMappedQnsbnData({},"DailySummaryReportSendTo");
          if(this.emailTouched && this.selected.size > 0){
            this.emailRequired = true;
          }
        }else{
          this._QnSbnDataService.getMappedQnsbnData({sendTo: this.sendTo},"DailySummaryReportSendTo");
            if(this.sendTo.length > 1 && (this.sendToControl.errors || !strictEmailPattern.test(this.sendTo))){
              this.invalidEmail = true;
            }else{
              this.invalidEmail = false;
            }
          this.emailRequired = false;
        }      
    })
  }

  public toggleEnable(checked) {
    this._QnSbnDataService.setDRToggle(checked);
    if (!checked) {
      // When toggle is OFF, clear all data
      this.selected.clear();
      this.sendToControl.setValue('', { emitEvent: false });
      this.sendTo = '';
      this.emailRequired = false;
      this.invalidEmail = false;
      this.emailTouched = false;
      this._QnSbnDataService.getMappedQnsbnData([], "DailySummaryReportContent");
      this._QnSbnDataService.getMappedQnsbnData({}, "DailySummaryReportSendTo");
    } else {
      
      const selectedArray = Array.from(this.selected);
      this._QnSbnDataService.getMappedQnsbnData(selectedArray, "DailySummaryReportContent");
      this._QnSbnDataService.getMappedQnsbnData({sendTo: this.sendTo || ''}, "DailySummaryReportSendTo");
    }
  }

  public contentSelection(options, event){
    const checked = event?.detail?.checked ?? event?.target?.checked ?? event;
    if (checked) {
      this.selected.add(options);
    } else {
      this.selected.delete(options);
    }
    const selectedArray = Array.from(this.selected);
    this._QnSbnDataService.getMappedQnsbnData(selectedArray, "DailySummaryReportContent");
    
    if(this.selected.size > 0){
      if((!this._QnSbnDataService.isEmpty(this.storedData.dailyReportSendTo) && this.storedData.dailyReportSendTo !== "")){
        this.emailRequired = false;
      }else if(this.emailTouched && (this.sendTo == "" || !this.sendTo)){
        this.emailRequired = true;
      }
    } else {
      this.emailRequired = false;
    }
  }

  public contentAllSelection(event){
    const checked = event?.detail?.checked ?? event?.target?.checked ?? event;
    if (checked) {
      this.reportContent.forEach(option => this.selected.add(option));
    } else {
      this.selected.clear();
    }
    const selectedArray = Array.from(this.selected);
    this._QnSbnDataService.getMappedQnsbnData(selectedArray, "DailySummaryReportContent");
    if(this.selected.size > 0){
      if((!this._QnSbnDataService.isEmpty(this.storedData.dailyReportSendTo) && this.storedData.dailyReportSendTo !== "")){
        this.emailRequired = false;
      }else if(this.emailTouched && (this.sendTo == "" || !this.sendTo)){
        this.emailRequired = true;
      }
    } else {
      this.emailRequired = false;
    }
  }

  public isAllSelected(){
    return this.selected.size === this.reportContent.length;
  }

  public onEmailBlur(){
    this.emailTouched = true;
    if((this.sendTo == "" || !this.sendTo) && this.selected.size > 0){
      this.emailRequired = true;
    }
  }
}
